import { Button } from "@mui/material"; // Importa el componente Button de Material UI
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'; // Importa el ícono de flecha hacia atrás de la librería de íconos de Material UI
import { useNavigate } from "react-router-dom"; // Importa el hook 'useNavigate' para manejar la navegación entre rutas

export default function Soundscape() { // Define el componente funcional Soundscape
  const navigate = useNavigate(); // Inicializa el hook de navegación para redirigir a otras rutas
  
  // Define los estilos para el iframe que contiene el reproductor de SoundCloud
  const iframeStyles = {
    width: '100%', // Establece el ancho del iframe al 100% del contenedor
    height: '100%', // Establece la altura del iframe al 100% del contenedor
    scrolling: 'no', // Desactiva el desplazamiento dentro del iframe
    frameborder: 'no', // Elimina el borde del iframe
    allow: 'autoplay', // Permite la reproducción automática del contenido dentro del iframe
  };

  // Define los estilos para el primer contenedor principal que contiene el reproductor de SoundCloud
  const containerStyles = {
    backgroundColor: 'rgb(97, 185, 207)', // Establece el color de fondo del contenedor
    height: '390px', // Define la altura del contenedor
    left: '361px', // Define la posición horizontal del contenedor
    position: 'absolute', // Establece la posición como absoluta
    top: '229px', // Define la posición vertical del contenedor
    width: '449px', // Define el ancho del contenedor
    zIndex: 100, // Establece el índice Z para el apilamiento de los elementos
  };

  // Define los estilos para el texto en el pie de la tarjeta debajo del reproductor
  const textStyles = {
    fontSize: '10px', // Establece el tamaño de la fuente
    color: '#cccccc', // Define el color del texto
    lineBreak: 'anywhere', // Permite el salto de línea en cualquier lugar
    wordBreak: 'normal', // Establece el comportamiento de corte de palabras
    overflow: 'hidden', // Oculta el contenido que excede los límites del contenedor
    whiteSpace: 'nowrap', // Evita que el texto se divida en varias líneas
    textOverflow: 'ellipsis', // Muestra puntos suspensivos cuando el texto es demasiado largo
    fontFamily: 'Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif', // Define la fuente del texto
    fontWeight: 100, // Establece el peso de la fuente
  };

  // Define los estilos para el segundo contenedor que contiene el texto adicional
  const containerStyles2 = {
    backgroundColor: 'rgb(6, 6, 4)', // Establece el color de fondo del contenedor
    color: 'rgb(177, 188, 174)', // Establece el color del texto dentro del contenedor
    height: '315px', // Define la altura del contenedor
    left: '897px', // Define la posición horizontal del contenedor
    position: 'absolute', // Establece la posición como absoluta
    top: '255px', // Define la posición vertical del contenedor
    width: '249px', // Define el ancho del contenedor
    zIndex: 100, // Establece el índice Z para el apilamiento de los elementos
  };

  return (
    <>
      <Button onClick={() => navigate("/sonidos")}> {/* Botón que redirige a la página principal (ruta "/") al hacer clic */}
        <ArrowBackIosNewOutlinedIcon /> {/* Muestra el ícono de flecha hacia atrás dentro del botón */}
      </Button>
      
      <div
        id="soundscape.head.166077097711" // Asigna un ID único al contenedor principal con el reproductor
        className="text resizable object" // Aplica clases CSS para estilo
        style={containerStyles} // Aplica los estilos al contenedor
      >
        <iframe
          style={iframeStyles} // Aplica los estilos al iframe
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1326110638&amp;color=%23ff5500&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;show_teaser=true&amp;visual=true" // URL del reproductor de SoundCloud con parámetros configurados
          allow="autoplay" // Permite la reproducción automática del contenido
          title="L-system soundscape" // Título del iframe
        />
        <div style={textStyles}> {/* Contenedor para el texto que aparece debajo del reproductor */}
          <a
            href="https://soundcloud.com/labvs-imate-unam" // Enlace al perfil de SoundCloud
            title="labvs.imate.unam" // Título del enlace
            target="_blank" // Abre el enlace en una nueva pestaña
            rel="noopener noreferrer" // Seguridad para abrir el enlace
            style={{ color: '#cccccc', textDecoration: 'none' }} // Estilo del enlace (sin subrayado y color claro)
          >
            labvs.imate.unam {/* Texto del enlace (nombre del usuario de SoundCloud) */}
          </a> · 
          <a
            href="https://soundcloud.com/labvs-imate-unam/l-system-soundscape" // Enlace al track de SoundCloud titulado "L-system soundscape"
            title="L-system soundscape" // Título del enlace
            target="_blank" // Abre el enlace en una nueva pestaña
            rel="noopener noreferrer" // Seguridad para abrir el enlace
            style={{ color: '#cccccc', textDecoration: 'none' }} // Estilo del enlace (sin subrayado y color claro)
          >
            L-system soundscape {/* Texto del enlace (nombre del track) */}
          </a>
        </div>
      </div>
      
      <div
        id="soundscape.head.166078939550" // Asigna un ID único al contenedor con el texto adicional
        className="text resizable object" // Aplica clases CSS para estilo
        style={containerStyles2} // Aplica los estilos al segundo contenedor
      >
        It all depends on what we discard in the measurement, because as we count with more and more precision, we must add the contour of bays, rocks, grains of sand, and so on down to subatomic levels. This is going to happen to us in every measurement, and since we do not have the coast of Britain at hand, we could experiment with anything. (Extract) {/* Texto citado */}
        <br />
        <br />
        Jaime Lobato, 2021. {/* Autor del extracto */}
      </div>    
    </>
  );
}
